module.exports = __webpack_public_path__ + "img/serve.ddab4836.png";